import { render, staticRenderFns } from "./createBd.vue?vue&type=template&id=7e77e2c8&scoped=true&"
import script from "./createBd.vue?vue&type=script&lang=js&"
export * from "./createBd.vue?vue&type=script&lang=js&"
import style0 from "./createBd.vue?vue&type=style&index=0&id=7e77e2c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e77e2c8",
  null
  
)

export default component.exports